<template>
  <v-container class="ma-0 pa-0" v-if="calendarId">

    <v-row no-gutters align="center" justify="space-around" class="pa-0 ma-0 pb-5">
      <v-col no-gutters class="pa-0 ma-0 pb-2 caption">

        <v-progress-linear indeterminate v-show="loading" class="my-1"></v-progress-linear>

        <v-date-picker v-model="date"
          full-width :landscape="$vuetify.breakpoint.smAndUp" locale="pt-br"
          :allowed-dates="allowedDates"
          class="pa-0 ma-0 mt-4"
          :picker-date.sync="pickerDate"
          @input="input" >
        </v-date-picker>

      </v-col>
    </v-row>

  </v-container>
</template>


<script>
import bus from '@/plugins/eventBus';

export default {
  props: {
    value: {
      type: String,
    },
    calendarId: {
      type: Number,
      required: true,
    },
    type: {
      type: String,
      dafault: 'normal',
    },
  },
  data: () => ({
    date: null,
    dates: [],
    pickerDate: null,
    loading: false,
  }),
  mounted() {
    this.pickerDate = this.$moment().format('YYYY-MM');
    bus.$on('schedule-refresh', this.getDates);
  },
  methods: {
    allowedDates(date) {
      return this.dates.includes(date);
    },
    getDates() {
      if (this.calendarId) {
        this.loading = true;
        this.$store
          .dispatch('calendars/getDates', { id: this.calendarId, date: `${this.pickerDate}-01`, type: this.type })
          .then((dates) => {
            const self = this;
            this.dates = dates.map(elem => self.$moment.utc(elem.date).format('YYYY-MM-DD'));
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    input() {
      this.$emit('input', this.date);
    },
  },
  watch: {
    calendarId() {
      this.getDates();
    },
    type() {
      this.getDates();
    },
    pickerDate() {
      this.getDates();
    },
  },
};
</script>

<style scoped>
  .time.v-chip.v-chip--active {
    background-color: #1976d2 !important;
    color: white !important;
  }
</style>
